import { config } from '../_config';
import { authHeader, handleResponse } from '../_helpers';

export const inscriptionService = {
  getUserOpenExpos,
  getExpo,
  getUserInscripcionData,
  getUserRedsysForm,
  uploadInscriptionData,
  getListaGrupoCria,
  getListaParejas
}

/* funcion para generar el form de redsys */
function getUserRedsysForm(datos) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      datos
    }
  }
  return fetch(`${config.apiUrl}/getUserGenerarRedsysForm`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });

}

/* funcion para recoger todas las exposiciones abiertas */
function getUserOpenExpos(canineId) {
  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader()
    }
  };
  return fetch(`${config.apiUrl}/getUserOpenExpos`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })
}

/* Funcion para  recoger los datos de una expo y poder usarla en las inscripciones */
function getExpo(expoId) {
  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader()
    }
  };
  return fetch(`${config.apiUrl}/getUserExpoData/${expoId}`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })
}

/* funcion para recoger los datos del usuario... relativos a la inscripcion */
function getUserInscripcionData() {
  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader()
    }
  };
  return fetch(`${config.apiUrl}/getUserInscripcionData`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })
}

function uploadInscriptionData(datos) {
  console.log(datos) 
  
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(datos)
  };
  console.log(requestOptions)

  return fetch(`${config.apiUrl}/uploadInscriptionData`, requestOptions).then(handleResponse);

}

/* FUNCION PARA TRAER A LOS PERROS DE GRUPO DE CRIA */
function getListaGrupoCria(datos) {
  //console.log(datos)
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(datos)
  }
  return fetch(`${config.apiUrl}/listaGrupoCria`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });

}

/* FUNCION PARA TRAER LOS DATOS DE LAS PAREJAS */
function getListaParejas(datos) {
  //console.log(datos)
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(datos)
  }
  return fetch(`${config.apiUrl}/listaParejas`, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    });

}